export const special = {
  version: "v0.0.1",
  title: "雲策投資股份有限公司",
  custom_name: "CloudWell Investment CO., LTD.",
};
